exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blocks>div[data-v-70fb786a]{display:grid;grid-gap:30px;grid-template-columns:1fr 150px 50px;padding-right:40px;position:relative\n}\n.blocks>div button[data-v-70fb786a]{top:40px\n}", ""]);

// exports
